import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionDetailsType } from "../../types/genericType";
import { formatDate } from "../../utils/dateFormat";
import { calculateDates } from "../../utils/utils";

type reconcileState = {
  statements: Array<TransactionDetailsType>;
  selectedTransaction?: TransactionDetailsType;
  timeframe: string;
  startFilterDate: string;
  endFilterDate: string;
};

const initialReconcileState: TransactionDetailsType = {
  id: 0,
  date: "",
  code: "Deposit",
  amount: 0,
  accountName: "",
  fromClientId: "",
  fromAccount: 0,
  account: 0,
  description: "",
  client: "",
  status: "",
  balance: 0,
  checkNumber: null,
  createdOn: "",
  bankTransactionType: undefined,
};

const currentDate = new Date();

const initialState: reconcileState = {
  statements: [],
  selectedTransaction: initialReconcileState,
  timeframe: "0",
  startFilterDate: formatDate(new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  )),
  endFilterDate: formatDate(currentDate),
};

export const reconcileSlice = createSlice({
  name: "reconcileState",
  initialState,
  reducers: {
    setStatementsState: (
      state,
      action: PayloadAction<TransactionDetailsType[]>
    ) => {
      state.statements = action.payload;
    },
    setSelectedRecTransaction: (
      state,
      action: PayloadAction<TransactionDetailsType>
    ) => {
      state.selectedTransaction = action.payload;
    },
    resetSelectedRecTransaction: (state) => {
      state.selectedTransaction = initialReconcileState;
    },
    setReconcileStatus: (
      state,
      action: PayloadAction<{ id: number; status: string }>
    ) => {
      state.statements = state.statements.map((statement) => {
        if (statement.id === action.payload.id) {
          statement.status = action.payload.status;
        }
        return statement;
      });
    },
    updateTimeframe: (state, action: PayloadAction<string>) => {
      const values = calculateDates(action.payload);
      state.timeframe = action.payload;
      state.startFilterDate = values?.[0] ?? "";
      state.endFilterDate = values?.[1] ?? "";
    },
    updateDates: (state, action) => {
      state.startFilterDate = action.payload.startDate;
      state.endFilterDate = action.payload.endDate;
    }
  },
});

export const {
  setStatementsState,
  setSelectedRecTransaction,
  resetSelectedRecTransaction,
  updateTimeframe,
  setReconcileStatus,
  updateDates
} = reconcileSlice.actions;

export default reconcileSlice.reducer;
